import { render, staticRenderFns } from "./Osa011.vue?vue&type=template&id=0d560d18&scoped=true"
var script = {}
import style0 from "./Osa011.vue?vue&type=style&index=0&id=0d560d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d560d18",
  null
  
)

export default component.exports